"use strict";
exports.__esModule = true;
function isWrappedFunction(m) {
    return typeof m.value === "function";
}
var Either = /** @class */ (function () {
    function Either(type, value) {
        this.type = type;
        this.value = value;
    }
    Either.mergeInOne = function (eithers) {
        return eithers.reduce(function (res, v) {
            return v.chain(function (v) { return res.map(function (res) { return res.concat([v]); }); });
        }, Either.right([]));
    };
    Either.mergeInMany = function (eithers) {
        return eithers.reduce(function (res, v) {
            if (res.isLeft()) {
                return v.isLeft() ? Either.left(res.value.concat([v.value])) : res;
            }
            return v.isLeft()
                ? Either.left([v.value])
                : v.chain(function (v) { return res.map(function (res) { return res.concat([v]); }); });
        }, Either.right([]));
    };
    Either.from = function (v) {
        return this.right(v);
    };
    Either.right = function (v) {
        return new Either("Right" /* Right */, v);
    };
    Either.left = function (v) {
        return new Either("Left" /* Left */, v);
    };
    Either.prototype.isLeft = function () {
        return this.type === "Left" /* Left */;
    };
    Either.prototype.isRight = function () {
        return this.type === "Right" /* Right */;
    };
    Either.prototype.join = function () {
        return this.chain(function (x) { return x; });
    };
    Either.prototype.mapRight = function (f) {
        return this.map(f);
    };
    Either.prototype.mapLeft = function (f) {
        if (this.isLeft()) {
            return Either.left(f(this.value));
        }
        return Either.right(this.value);
    };
    Either.prototype.map = function (f) {
        if (this.isLeft()) {
            return Either.left(this.value);
        }
        return Either.right(f(this.value));
    };
    Either.prototype.asyncMap = function (f) {
        if (this.isLeft()) {
            return Promise.resolve(Either.left(this.value));
        }
        return f(this.value).then(function (v) { return Either.right(v); });
    };
    Either.prototype.apply = function (argOrFn) {
        if (this.isLeft()) {
            return Either.left(this.value);
        }
        if (argOrFn.isLeft()) {
            return Either.left(argOrFn.value);
        }
        if (isWrappedFunction(this)) {
            return argOrFn.map(this.value);
        }
        if (isWrappedFunction(argOrFn)) {
            return argOrFn.apply(this);
        }
        throw new Error("Some of the arguments should be a function");
    };
    Either.prototype.asyncApply = function (argOrFn) {
        if (this.isLeft()) {
            return Promise.resolve(Either.left(this.value));
        }
        if (argOrFn.isLeft()) {
            return Promise.resolve(Either.left(argOrFn.value));
        }
        if (isWrappedFunction(this)) {
            return argOrFn.asyncMap(this.value);
        }
        if (isWrappedFunction(argOrFn)) {
            return argOrFn.asyncApply(this);
        }
        throw new Error("Some of the arguments should be a function");
    };
    Either.prototype.chain = function (f) {
        if (this.isLeft()) {
            return Either.left(this.value);
        }
        return f(this.value);
    };
    Either.prototype.asyncChain = function (f) {
        if (this.isLeft()) {
            return Promise.resolve(Either.left(this.value));
        }
        return f(this.value);
    };
    Either.merge = Either.mergeInOne;
    return Either;
}());
exports["default"] = Either;
